import React, { useRef, useState, useEffect } from 'react';
import './CongratulationCard.css';

function CongratulationCard({ personName, voiceMessage, sticker, quote, onVoiceToggle }) {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);
    const onEnded = () => setIsPlaying(false);

    if (audio) {
      audio.addEventListener('play', onPlay);
      audio.addEventListener('pause', onPause);
      audio.addEventListener('ended', onEnded);
    }

    return () => {
      if (audio) {
        audio.removeEventListener('play', onPlay);
        audio.removeEventListener('pause', onPause);
        audio.removeEventListener('ended', onEnded);
      }
    };
  }, []);

  return (
    <div className="congratulation-card">
      <img src={sticker} alt={`Стикер от ${personName}`} className="sticker" />
      <h3 className="person-name">{personName}</h3>
      <p className="quote">"{quote}"</p>
      <button
        className={`play-button ${isPlaying ? 'playing' : ''}`}
        onClick={() => onVoiceToggle(audioRef)}
      >
        {isPlaying ? '⏸ Остановить' : '▶ Слушать'}
      </button>
      <audio ref={audioRef} preload="auto">
        <source src={voiceMessage} type="audio/mpeg" />
        Ваш браузер не поддерживает воспроизведение аудио.
      </audio>
    </div>
  );
}

export default CongratulationCard;
